"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierUpgradeModal = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var TierUpgradeModal = /** @class */ (function (_super) {
    __extends(TierUpgradeModal, _super);
    function TierUpgradeModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCloseClick = function () {
            _this.props.onClose();
        };
        return _this;
    }
    TierUpgradeModal.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.handleCloseClick });
        return (React.createElement(reactstrap_1.Modal, { className: "info-modal tier-upgrade-modal", isOpen: this.props.showModal, toggle: this.handleCloseClick },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.handleCloseClick, close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "info-icon" }),
                    React.createElement("div", { className: "text-blue-2" }, this.props.title))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                React.createElement("div", null,
                    this.props.explanation,
                    React.createElement("p", { className: "font-weight-semi-bold" }, this.props.query))),
            React.createElement(reactstrap_1.ModalFooter, { className: "justify-content-between width-100" },
                this.props.tierUpgradeButtons.map(function (button) { return (React.createElement("button", { key: button.key, type: "button", className: "btn btn-primary btn-add ".concat(button.hide && "d-none"), onClick: button.onClick }, button.buttonText)); }),
                React.createElement("button", { className: "btn btn-back", onClick: this.handleCloseClick }, "No, thanks"))));
    };
    return TierUpgradeModal;
}(React.Component));
exports.TierUpgradeModal = TierUpgradeModal;
//# sourceMappingURL=TierUpgradeModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/TierUpgradeModal.js
// module id = 3221
// module chunks = 0